import layers from './zLayerNames.json';

export const Z_LOCAL_LAYERS: Record<string, string> = layers.local;

export const Z_NAMED_LAYERS: Record<string, string> = layers.named;

export const Z_LAYERS = { ...Z_LOCAL_LAYERS, ...Z_NAMED_LAYERS };
